import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { ComplaintBook } from "../../Domain/Model/ComplaintBook";
import { ComplaintBooks } from "../../Domain/Model/ComplaintBooks";
import ComplaintBookRepository from "../../Domain/Repository/ComplaintBookRepository";
import ComplaintBookDataSource from "../Datasource/ComplaintBookDataSource";

export class ComplaintBookRepositoryImpl implements ComplaintBookRepository {
    dataSource:  ComplaintBookDataSource;

    constructor(_dataSource: ComplaintBookDataSource){
        this.dataSource = _dataSource;
    }

    getComplaintBooks(page: number, pageSize: number, search: string): Promise<PaginationResult<ComplaintBooks>> {
        return this.dataSource.getComplaintBooks(page, pageSize,search);
    }
    getComplaintBooksById(id: number): Promise<ComplaintBook | null> {
        return this.dataSource.getComplaintBooksById(id);
    }
}